import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { ContactUs, IStrapiDocuments } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import { NgIf, NgFor } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { PageRetrievalErrorComponent } from '../../../shared/components/page-retrieval-error/page-retrieval-error.component';
import { CmsLinkComponent } from '../../../shared/components/cms-link/cms-link.component';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        BreadcrumbsComponent,
        PageRetrievalErrorComponent,
        NgFor,
        CmsLinkComponent,
    ],
})
export class ContactUsComponent extends PageComponent implements OnInit {
  public override pageData: ContactUs = <ContactUs>{};

  private cdr = inject(ChangeDetectorRef);

  constructor(
    public override readonly titleService: Title,
    public override readonly metaService: Meta,

    public override readonly strapi: StrapiService,
    public readonly auth: AuthService
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.strapi
      .getDocumentByUID('contact-uses', 'contact-us', {
        populate: {
          contact_options: { populate: ['image'] },
          image_web: { populate: '*' },
        },
      })
      .subscribe({
        next: (data: IStrapiDocuments<ContactUs>) => {
          this.parsePageData(data.data[0].attributes);
          super.setMetas();
          this.cdr.markForCheck()
        },
        error: () => {
          this.pageRetrievalError = true;
        },
      });
  }

  protected override parsePageData(page: ContactUs): void {
    super.parsePageData(page);

    this.pageData = page;
  }
}
